import { Component, Output, Input, EventEmitter, OnChanges } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import { encodeUtf8 } from '@core/_utils/tools.utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-form-editors',
    templateUrl: './form-editors.component.html',
    styleUrls: ['./form-editors.component.scss'],
    providers: [AutofocusDirective],
})
export class FormEditorsComponent extends FormBase implements OnChanges {
    public requestForm: FormGroup;
    public validClick = false;
    public listColumns: any[];
    public isAdmin = false;

    @Input()
    public item: any;

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.requestForm = this.formBuilder.group({
            id: null,            
            desc: [{ value: null, disabled: true }],
            displayValue: [null, [Validators.required]],
            useValue: [null, [Validators.required]],
        });
        this.initialization();
    }

    ngOnChanges() {
        if (this.item) {
            this.requestForm.patchValue(this.item);
        }
    }

    public validate() {
        let wResult: any;
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.item.type === 'Combo') {
            this.requestForm.value.displayValue = this.requestForm.value.useValue;
        }
        if (this.requestForm.invalid) {
            this.getErrorsInputs(error, this.requestForm);
        } else {
            wResult = this.verify(this.requestForm.value.displayValue, this.requestForm.value.useValue);
            if (wResult.result === true) {                
                this.onValidate.emit(this.formatRequest(this.item, wResult));
            } else {
                this._messageService.addErrorNoStick(this.translate.instant('Edt_Line'));
            }
        }
    }

    private formatRequest(aItem, aResult) {
        let wRequest = {};
        if (aItem.type === 'ComboCustom') {
            wRequest = {
                type: aItem.type,
                CustomEditorName: aItem.name,
                Values: this.prepareValues(aResult.useValue),
                Shows: this.prepareValues(aResult.displayValue),
            };
        } else {
            wRequest = {
                type: aItem.type,
                CustomEditorName: aItem.name,
                Values: this.prepareValues(aResult.useValue),
            };
        }
        return wRequest;
    }

    private prepareValues(aData) {
        return encodeUtf8(aData.map(item => {
            return '"' + item + '"'
        }).join())
    }

    private verify(aDisplayValue, aUseValue) {
        let wResult = {};
        let wDisplayValue = [];
        let wUseValue = [];    
        wDisplayValue = aDisplayValue.split('\n');
        wUseValue = aUseValue.split('\n');
        wDisplayValue = wDisplayValue.filter((item) => {
            return item !=='';
        });
        wUseValue = wUseValue.filter((item) => {
            return item !=='';
        });
        if (wDisplayValue.length === wUseValue.length) {
            wResult = {
                result: true,
                useValue: wUseValue,
                displayValue: wDisplayValue
            }
        } else {
            wResult = {
                result: false
            }
        }
        return wResult;
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    private initialization() {
        this.keys = {
            displayValue: {
                label: this.translate.instant('Val_Dis'),
                pattern: '',
            },
            useValue: {
                label: this.translate.instant('Val_Set'),
                pattern: '',
            },
        };
        
        this.listColumns = [
            {
                field: 'Name',
                header: this.translate.instant('Name'),
            },
            {
                field: 'Label',
                header: this.translate.instant('Label'),
            },
        ];
    }
}
